export default __webpack_public_path__ + "img/flHokCyq.ab77110b.svg";